import { render, staticRenderFns } from "./statAppointFeeDates2.vue?vue&type=template&id=60190b60"
import script from "./statAppointFeeDates2.vue?vue&type=script&lang=js"
export * from "./statAppointFeeDates2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports